export default __webpack_public_path__ + "static/media/running.d01cf2c0.svg";